import { createContext, useContext, useState, useEffect } from 'react';
import useTranslations from '../hooks/useTranslations';

export const TranslationContext = createContext({
  translations: {},
  loading: false,
  // Taal waar de huidige vertalingen bij horen. Verschilt die van de gevraagde
  // taal, dan loopt er nog een vertaalronde — daar hangt de laadindicator aan.
  language: null,
  setTranslationInput: () => {},
});

export const TranslationProvider = ({ children }) => {
  const [input, setInput] = useState({ strings: {}, language: 'nl' });

  const { translations, loading, language } = useTranslations(input.strings, input.language);
  
  return (
    <TranslationContext.Provider value={{ 
      translations, 
      loading, 
      language,
      setTranslationInput: ({ strings, language }) => setInput({ strings, language }) 
    }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
